/* eslint-disable */
// checkout/steps/reviewAndConfirmListeners.ts

import { toggleState } from '../../utils/toggleState';
import { initRcLoqateLookup } from '../utils/initRcLoqateLookup';

/**
 * Adds event listeners to the "Review and Confirm" form elements.
 * @returns {void}
 */
export function addReviewAndConfirmListeners(): void {
	const form = document.getElementById('reviewAndConfirmFormHandle') as HTMLFormElement | null;

	if (form) {

		/** Toggle delivery notes update button when input keyup detected **/
		const deliveryNotesInput = form.querySelector(
			'.form__row--delivery-notes input[type="text"]',
		) as HTMLInputElement;

		deliveryNotesInput?.addEventListener('keyup', () => {
			const btn = form.querySelector('#delivery-notes__btn') as HTMLButtonElement;
			if (!btn) return;

			const hasValue = deliveryNotesInput.value.trim().length > 0;
			const isHidden = btn.hasAttribute('hidden');

			if ((hasValue && isHidden) || (!hasValue && !isHidden)) {
				toggleState([btn], 'hidden');
			}
		});
		const fire = () => {
			window.GTM?.createCheckoutEvent?.('review');
		};
		if (document.readyState === 'complete') {
			fire();
		} else {
			window.addEventListener('load', fire, { once: true });
		}
	}

	/** Get customer number from window.serverData entry and push to GTM dataLayer **/
	const customerNumber = window.serverData?.customerNumber;

	if (customerNumber) {
		window.dataLayer = window.dataLayer || [];

		const checkCustomerNumberEntry = window.dataLayer?.some(
			(item: any) => item.customer_number === customerNumber,
		);

		if (!checkCustomerNumberEntry) {
			window.dataLayer.push({
				event: 'customer_authenticated',
				customer_number: customerNumber,
				auth_context: 'checkout_login',
			});
		}
	}

	initRcLoqateLookup();
}